/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TranslationDraft } from './TranslationDraft';
import {
    TranslationDraftFromJSON,
    TranslationDraftFromJSONTyped,
    TranslationDraftToJSON,
    TranslationDraftToJSONTyped,
} from './TranslationDraft';

/**
 * 
 * @export
 * @interface GetMissingTranslationsResponse
 */
export interface GetMissingTranslationsResponse {
    /**
     * 
     * @type {Array<TranslationDraft>}
     * @memberof GetMissingTranslationsResponse
     */
    drafts: Array<TranslationDraft>;
}

/**
 * Check if a given object implements the GetMissingTranslationsResponse interface.
 */
export function instanceOfGetMissingTranslationsResponse(value: object): value is GetMissingTranslationsResponse {
    if (!('drafts' in value) || value['drafts'] === undefined) return false;
    return true;
}

export function GetMissingTranslationsResponseFromJSON(json: any): GetMissingTranslationsResponse {
    return GetMissingTranslationsResponseFromJSONTyped(json, false);
}

export function GetMissingTranslationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMissingTranslationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'drafts': ((json['drafts'] as Array<any>).map(TranslationDraftFromJSON)),
    };
}

export function GetMissingTranslationsResponseToJSON(json: any): GetMissingTranslationsResponse {
    return GetMissingTranslationsResponseToJSONTyped(json, false);
}

export function GetMissingTranslationsResponseToJSONTyped(value?: GetMissingTranslationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'drafts': ((value['drafts'] as Array<any>).map(TranslationDraftToJSON)),
    };
}

